const mapCarrierService = carrierService => ({
  id: carrierService.id,
  name: carrierService.name,
  service_name: carrierService.service_name,
  is_reveni_contract: carrierService.is_reveni_contract,
  is_pickup_point: carrierService.is_pickup_point,
  is_connected: carrierService.is_connected,
  logo_url: carrierService.logo_url,
  source_region_ids: carrierService.source_region_ids,
  destination_region_ids: carrierService.destination_region_ids,
})

export const transformResponseCarrierServices = carrierServices => carrierServices.map(mapCarrierService)
